import React, { useEffect, useState } from "react";
import lpllogo from "../assets/images/logo.png";
import suburbanlogo from "../assets/images/suburban.webp"
import user from "../assets/images/user.png";
import Dropdown from "react-bootstrap/Dropdown";
import ApiRequest from "../services/apiService";
import "../assets/stylesheet/dashboard.scss";
import getUserDetails from "../utilities/getUserDetails";
import baseUrl from "../services/baseUrl";
import LogoutButton from "../Auth/logout";
import { useNavigate } from "react-router-dom";
import handleLogout from "../Auth/logout";
import NumberFormatter from "../utilities/formatHeaderCounts";
import { ShowToastUtil } from "../utilities/showToastUtil";
import HeaderScreenLoader from "../components/headerScreenLoader";

export default function DashboardHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [ppdCounts, setPpdCounts] = useState({});
  const [userInfo, setUserInfo] = useState(getUserDetails());
  const [IsLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [projectFilter, setProjectFilter] = useState(
    localStorage.getItem("projectFilter") || ""
  );

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
  };

  //company
  const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";

  useEffect(() => {
    const fetchHeaderData = async () => {
      // Check if the data already exists in localStorage
      const storedData = localStorage.getItem('headerData');
      if (storedData) {
        setPpdCounts(JSON.parse(storedData));
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        const params = new URLSearchParams({
          // projectFilter: localStorage.getItem('projectFilter') || projectFilter,
          userRole: userInfo.UserRole,
          userCode: userInfo.UserCode,
          userCompany: userInfo.userCompany,
        });
        const url = `${baseUrl()}/nps/GetNpsHeaderData?${params.toString()}`;
        const responseData = await ApiRequest({ apiLink: url, method: 'GET' });
        if (responseData.Data && responseData.IsSuccess) {
          setIsLoading(false);
          const data = responseData.Data.Counts;
          setPpdCounts(data || {});
          localStorage.setItem('headerData', JSON.stringify(data)); // Store data in localStorage
        }
      } catch (error) {
        ShowToastUtil('Error fetching header data:', error);
      }
    };

    fetchHeaderData();
  }, [projectFilter, userInfo.UserRole, userInfo.UserCode]);

  async function handleLogout() {
    try {
      const params = new URLSearchParams({
        userCode: userInfo.UserCode,
        logoutTime: new Date().toISOString(),
      });
      const url = `${baseUrl()}/nps/RemoveUserTrail?${params.toString()}`;
      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
      });

      if (response.Message === "Success") {
        if (isSuburban) {
          navigate('/sdpllogin');
        } else {
          navigate('/login');
        }
      } else {
        ShowToastUtil(
          response.Description || "Failed to delete user trail",
          "error"
        );
      }
    } catch (error) {
      ShowToastUtil("Something went wrong with user trail deletion", "error");
    }


    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleDropdownLogout = () => {
    handleLogout();
  };


  //const isSuburbon = true


  return (
    <header
      className={`main-header container-fluid ${isScrolled ? "scrolled" : ""}`}
    >
      <div className="row">
        <div className="col-12 d-flex align-items-center">

          {/* <img alt="Dr. Lal Path Labs" src={lpllogo} className="img-fluid" /> */}
          <a href={'/home'} className="logo">
            {isSuburban ? (
              <img
                alt="Suburban Diagnostics India Pvt Limited"
                src={suburbanlogo}
                className="img-fluid"
              />
            ) : (
              <img
                alt="Dr. Lal Path Labs"
                src={lpllogo}
                className="img-fluid"
              />
            )}
          </a>
          <h3 className="npsHeader">Net Promoter Score</h3>
          <div className="ms-auto d-inline-flex">
            <div className="h-promotors me-3">
              <div>
                <span>Promoters</span>
                <span className="smily">
                  <i className="fa fa-smile-o" aria-hidden="true"></i>
                </span>
                <div className="count-number">
                  {IsLoading ? (
                    <div className="">
                      <HeaderScreenLoader />
                    </div>
                  ) : (
                    <NumberFormatter number={ppdCounts.Promoters || 0} />
                  )}
                </div>
              </div>
            </div>
            <div className="h-passives me-3">
              <div>
                <span>Passives</span>
                <span className="smily">
                  <i className="fa fa-meh-o" aria-hidden="true"></i>
                </span>
                <div className="count-number">
                  {IsLoading ? (
                    <div className="">
                      <HeaderScreenLoader />
                    </div>
                  ) : (
                    <NumberFormatter number={ppdCounts.Passives || 0} />
                  )}
                </div>
              </div>
            </div>
            <div className="h-detractors me-3">
              <div>
                <span>Detractors</span>
                <span className="smily">
                  <i className="fa fa-frown-o" aria-hidden="true"></i>
                </span>
                <div className="count-number">
                  {IsLoading ? (
                    <div className="">
                      <HeaderScreenLoader />
                    </div>
                  ) : (
                    <NumberFormatter number={ppdCounts.Detractors || 0} />
                  )}
                </div>
              </div>
            </div>
            <div className="user-info me-3">
              <Dropdown align={{ sm: "end" }}>
                <Dropdown.Toggle variant="user-icon">
                  <img alt="" src={user} className="user-image img-fluid" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div className="text-center user-N">
                    <span>Welcome</span>
                    <div className="text-nowrap user-name">
                      {userInfo?.UserName || ""}
                    </div>
                    <div className="user-designation">
                      {userInfo?.UserRole || ""}
                    </div>
                  </div>
                  <Dropdown.Item className="user-option" href="resetPassword">
                    <i className="fa fa-lock" aria-hidden="true"></i> Reset
                    Password
                  </Dropdown.Item>
                  {/* <Dropdown.Item
                    className="user-option"
                    // href="#"
                  >
                    <i className="fa fa-sign-out" aria-hidden="true"></i> <LogoutButton/>
                  </Dropdown.Item> */}
                  <Dropdown.Item onClick={handleDropdownLogout} className="user-option">
                    <i className="fa fa-sign-out" aria-hidden="true"></i> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
